import {Injectable} from '@angular/core'
import {Actions, createEffect, ofType} from '@ngrx/effects'
import {tap} from 'rxjs'
import {
  show_error_action,
  show_success_msg_action,
  show_success_msg_after_updation_action
} from '../action/common/common.action'
import {CommonService} from 'src/services/common/common.service'

@Injectable()
export class CommonEffects {
  constructor(private actions$: Actions, private cs: CommonService) {}

  show_error_action$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(show_error_action),
        tap(({ error }) => {
          try {
            let parsedJson = JSON.parse(error?.message)
            if(parsedJson?.error?.debugMessage) {
              this.cs.showError(parsedJson?.error?.message + "<br />" + parsedJson?.error?.debugMessage)
            } else {
              this.cs.showError(parsedJson?.error?.message)
            }
          } catch (e) {
            this.cs.showError('Something went wrong')
          }
        })
      )
    },
    { dispatch: false }
  )


  show_success_msg_after_updation_action$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(show_success_msg_after_updation_action),
        tap(({ moduleName }) => {
          this.cs.showSuccess(`${moduleName} updated successfully`)
        })
      )
    },
    { dispatch: false }
  )

  show_success_msg_action$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(show_success_msg_action),
        tap(({ msg }) => {
          this.cs.showSuccess(msg)
        })
      )
    },
    { dispatch: false }
  )
}
